import { FC, ReactNode } from 'react';

interface TableHeadProps {
    children?: ReactNode;
}

const TableHead: FC<TableHeadProps> = ({ children }) => <thead>{children}</thead>;

export default TableHead;
